export default {
    book_now: 'Rezervēt tagad',
    minimum_age: 'Vienīgi {age}',
    excess_liability: 'Papildus saistības',
    security_deposit: 'Drošības nauda',
    fuel_policy: 'Degvielas politika',
    like_for_like: 'Patīk pret patīk',
    full_to_full: 'Pilns pret pilnu',
    miles_per_rental: '{mileage} bezmaksas jūdzes par rezervācijas reizi',
    km_per_rental: '{mileage} bezmaksas kilometri par rezervācijas reizi',
    unlimited_mileage: 'Neierobežots jūdžu skaits',
    unlimited_mileage_km: 'Neierobežots km skaits',
    non_amendable: 'Nav maināms',
    non_refundable: 'Neatmaksājams',
    free_cancellation_until: 'Bezmaksas atcelšana līdz',
    cancellation_in_line_with: 'Atcelšana saskaņā ar',
    tcs: 'Noteikumi un nosacījumi',
    free_extras_on_collection: 'Divas bezmaksas ekstras savācot transportlīdzekli',
    glass_and_tyres_covered: 'Stikls un riepas nosegtas',
    number_of_passengers: 'Pasažieru skaits',
    number_of_bags: 'Somu skaits',
    fuel_type: 'Degvielas tips',
    co2: 'CO2',
    aircon: 'Gaisa konc.',
    transmission: 'Transmisija',
    book_type: 'Rezervēt {type}',
    debit_card_deposit: 'Debetkarte pieņemta par noguldījumiem',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/lv/quotes/price_card.js